var map = {
	"./de/cv-play.png": "y+VG",
	"./en/cv-play.png": "RmqZ",
	"./es/cv-play.png": "SBNG",
	"./fr/cv-play.png": "bu8X",
	"./ja/cv-play.png": "AgKm",
	"./ko/cv-play.png": "3bqN",
	"./pt/cv-play.png": "Ck52",
	"./ru/cv-play.png": "fLDC",
	"./tc/cv-play.png": "rr6L",
	"./th/cv-play.png": "Cdqg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yk3x";